import { render, staticRenderFns } from "./ot-go-to.vue?vue&type=template&id=c244e49e&scoped=true&"
import script from "./ot-go-to.vue?vue&type=script&lang=ts&"
export * from "./ot-go-to.vue?vue&type=script&lang=ts&"
import style0 from "./ot-go-to.vue?vue&type=style&index=0&id=c244e49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c244e49e",
  null
  
)

export default component.exports